import React, { Component } from 'react'
import { Select, FormControl, InputLabel } from '@material-ui/core'

export class UserType extends Component {
  render() {
    return (
      <FormControl
        variant="outlined"
        className={'text-field-style'}
        margin="dense"
        style={{
          margin: '6px',
          width: '256px'
        }}
        name="type">
        <InputLabel required className="text-color" htmlFor="type">
          User Type
        </InputLabel>

        <Select
          native
          label="User Type"
          value={(this.props.type && this.props.type) || ''}
          id="type"
          inputProps={{
            name: 'type'
          }}
          onChange={this.props.onChange}>
          <option aria-label="None" value="" />
          <option value="admin">Admin</option>
          <option value="member">Member</option>
          <option value="client">Client</option>
        </Select>
      </FormControl>
    )
  }
}

export default UserType
